
<div class="audit-log-view">
  <page-header title="Audit Log" />

  <align flex collapse-end direction="flex-start">
    <div class="search-container">
      <search-area
        v-model="query"
        class="input"
      />
    </div>

    <align small-gap>
      <pill-dropdown
        v-model="type"
        :options="typeFilterOptions"
      />

      <pill-dropdown
        v-if="isAdmin"
        v-model="employee"
        :options="employeeFilterOptions"
      />
    </align>
  </align>

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results for your query"
      description="Try searching for something else"
    />

    <template>
      <div class="list">
        <audit-log-item
          v-for="log in logs"
          :key="log.id"
          :log="log"
        />
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="nextPage"
      />
    </template>
  </div>

  <scroll-top />
</div>
